//=======================| App Configuration |========================//
export default {
	// appLogo: '/static/images/logo.png', 
	// appLogoDark: '/static/images/logo-dark.png',                         // App Logo,
	// brand: 'Embryo',                                        		   // Brand Name
	// copyrightText: '© All Rights Reversed | Made With Love by IRON NETWORK for better Web',     // Copyright Text
	//theme color
	color: {
      primary: '#000000',
      accent : '#000000',
      secondary : '#FFFFFF',
	},
	// algoliaApiKey: '6be0576ff61c053d5f9a3225e2a90f76'
}

// primary: '#8f2c34',